(function(){
 'use strict';
 function initialise(){
  document.querySelectorAll('.hok-home-feature [data-wetheme-section-type="product--featured-product"]').forEach(function(root){
   if(root.dataset.hokFeaturePriceReady)return;
   var json=root.querySelector('.hok-feature-prices');
   var select=root.querySelector('select[name="id"]');
   var price=root.querySelector('[data-hok-feature-price]');
   var fee=root.querySelector('[data-hok-feature-fee]');
   if(!json || !select || !price)return;
   var prices;
   try{prices=JSON.parse(json.textContent);}catch(error){return;}
   root.dataset.hokFeaturePriceReady='true';
   function update(){
    var picker=root.querySelector('[data-hok-variant-picker]');
    var label=picker && picker.querySelector('[data-hok-picker-label]');
    if(label)label.textContent='Size';
    root.querySelectorAll('.hok-size-choice-status').forEach(function(status){
     if(!status.classList.contains('hok-size-choice-status--ready') && !status.classList.contains('hok-size-choice-status--tailored'))status.remove();
    });
    var delivery=root.querySelector('[data-hok-feature-delivery]');
    var chosen=picker && picker.dataset.hokCustomerSelected==='true';
    var current=prices[String(select.value)];
    if(delivery)delivery.hidden=Date.now()>Date.parse(delivery.dataset.cutoff) || Boolean(chosen && current && current.tailored);
    if(picker && picker.dataset.hokCustomerSelected!=='true'){
     price.textContent=price.dataset.hokStartingPrice;
     if(fee)fee.hidden=true;
     return;
    }
    var entry=prices[String(select.value)];
    if(!entry)return;
    price.textContent=entry.amount;
    if(fee)fee.hidden=!entry.tailored;
    root.querySelectorAll('.hok-size-choice-status').forEach(function(status){
     if(!status.classList.contains('hok-size-choice-status--ready') && !status.classList.contains('hok-size-choice-status--tailored'))status.remove();
    });
   }
   function schedule(){update();window.setTimeout(update,50);window.setTimeout(update,250);}
   root.addEventListener('change',schedule);
   root.addEventListener('input',schedule);
   root.addEventListener('click',function(event){if(event.target.closest('[data-hok-variant-id]'))schedule();});
   update();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialise);else initialise();
 document.addEventListener('shopify:section:load',initialise);
})();
